import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, FileText, User, LogOut, ReceiptIndianRupee } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

const NAV = [
  { to: "/portal", label: "Home", icon: LayoutDashboard, end: true, id: "home" },
  { to: "/portal/payslips", label: "Payslips", icon: FileText, id: "payslips" },
  { to: "/portal/profile", label: "Profile", icon: User, id: "profile" },
];

export default function EmployeeLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-background pb-20 md:pb-0">
      <header className="sticky top-0 z-30 bg-card border-b border-border">
        <div className="max-w-2xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-md bg-[#FF4500] flex items-center justify-center">
              <ReceiptIndianRupee className="w-4 h-4 text-white" />
            </div>
            <span className="font-display font-semibold text-sm">My Payslips</span>
          </div>
          <div className="flex items-center gap-2">
            {/* Desktop nav */}
            <nav className="hidden md:flex items-center gap-1 mr-2">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} end={n.end} data-testid={`nav-${n.id}`}
                  className={({ isActive }) => cn("px-3 py-1.5 rounded-md text-sm transition-colors",
                    isActive ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground")}>
                  {n.label}
                </NavLink>
              ))}
            </nav>
            <Button variant="ghost" size="sm" onClick={doLogout} data-testid="logout-button" className="gap-1.5">
              <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Sign out</span>
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-6">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-card border-t border-border flex">
        {NAV.map((n) => (
          <NavLink key={n.to} to={n.to} end={n.end} data-testid={`bottomnav-${n.id}`}
            className={({ isActive }) => cn("flex-1 flex flex-col items-center gap-1 py-2.5 text-[11px]",
              isActive ? "text-[#FF4500]" : "text-muted-foreground")}>
            <n.icon className="w-5 h-5" />
            {n.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
